import userInfoindex from './userInfoindex.vue'

let a = Object.assign({ userInfoindex, })
export default a;
